import { render, staticRenderFns } from "./ForgetPassWord.vue?vue&type=template&id=3b9eda56&scoped=true&"
import script from "./forgetpassword.js?vue&type=script&lang=js&"
export * from "./forgetpassword.js?vue&type=script&lang=js&"
import style0 from "./ForgetPassWord.vue?vue&type=style&index=0&id=3b9eda56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9eda56",
  null
  
)

export default component.exports